

































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'


import DigitalCurrency6AccountUserProfilePicture from '../basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'

import { isValidHttpUrl } from '../basic-type-4-user-interface/service-for-algorithms/algorithms-1-is-valid-http-url'


import {
  MessageHtmlItem,
  HTML_ITEM_ID_CHIP,
  HTML_ITEM_ID_ICON_WITH_TEXT
} from '../../../../service-for-game-evaluation-loop/game-evaluation-loop-type-2-support/support-type-2-random/random-type-2-store/service-for-store-support-vectors/store-support-vectors-type-1-data-structures/data-structures-1-root-state'

@Component({
  components: {
    DigitalCurrency6AccountUserProfilePicture
  }
})
class UserInterface6HtmlReader extends Vue {

  @Prop({ default: '' }) messageString?: string
  @Prop({ default: () => [] }) messageHtmlItemList?: MessageHtmlItem[]

  HTML_ITEM_ID_CHIP = HTML_ITEM_ID_CHIP
  HTML_ITEM_ID_ICON_WITH_TEXT = HTML_ITEM_ID_ICON_WITH_TEXT


  isValidHttpUrl = isValidHttpUrl

  getUpdatedMessage () {
    let messageStringList: string[] = [this.messageString || '']
    let updatedMessageObjectList: MessageHtmlItem[] = []

    // Split the message into chip-separated sections
    if (this.messageHtmlItemList) {
      for (let i = 0; i < this.messageHtmlItemList.length; i++) {
        const htmlItemId = `{{html${i + 1}}}`
        const htmlItemId2 = `{{html${i + 1}-processed}}`

        for (let j = 0; j < messageStringList.length; j++) {
          const messageString = messageStringList[j]
          let messageStringHtmlSeparatedList = messageString.split(htmlItemId)
          const isSplit = messageStringHtmlSeparatedList.length >= 2

          if (!isSplit) {
            continue
          }

          messageStringHtmlSeparatedList = messageStringHtmlSeparatedList.map((stringValue: string) => `${stringValue}${htmlItemId2}`)
          messageStringHtmlSeparatedList[messageStringHtmlSeparatedList.length - 1] = messageStringHtmlSeparatedList[messageStringHtmlSeparatedList.length - 1].split(`${htmlItemId2}`)[0]
          messageStringHtmlSeparatedList = messageStringHtmlSeparatedList.filter((stringValue: string) => stringValue ? true : false)

          messageStringList = [...messageStringList.slice(0, j), ...messageStringHtmlSeparatedList, ...messageStringList.slice(j + 1, messageStringList.length)]
        }
      }

      for (let i = 0; i < messageStringList.length; i++) {
        const messageString = messageStringList[i]
        let hasChipItem = false

        for (let j = 0; j < this.messageHtmlItemList.length; j++) {
          const htmlItemId2 = `{{html${j + 1}-processed}}`
          const messageStringHtmlSeparatedList = messageString.split(htmlItemId2)
          const isSplit = messageStringHtmlSeparatedList.length >= 2
          const isMessageEqualToHtmlItemId2 = messageString === htmlItemId2

          if (!isSplit) {
            continue
          }

          hasChipItem = true

          if (!isMessageEqualToHtmlItemId2) {
            updatedMessageObjectList.push({
              ...this.messageHtmlItemList[j],
              isHtmlItem: false,
              iconImageUrl: '',
              text: messageStringHtmlSeparatedList[0]
            })
          }

          updatedMessageObjectList.push({
            ...this.messageHtmlItemList[j],
            isHtmlItem: true
          })
        }

        if (!hasChipItem) {
          updatedMessageObjectList.push({
            htmlItemId: '',
            isHtmlItem: false,
            iconImageUrl: '',
            text: messageString
          })
        }
      }
    }

    return updatedMessageObjectList
  }
}

export default UserInterface6HtmlReader

